import {
	providerAttrGlobalApply,
	providerAttrGlobalAssign,
	providerAttrGlobalAssignConfirm,
	providerAttrGlobalAssignEdit,
	providerAttrGlobalAssignPaginate,
	providerAttrIndividualApply
} from 'api/ProviderAttrGlobalUploadApi'
import {
	ICrudApplyProviderAttrFiltersSaga,
	ICrudApplyProviderAttrIndividualSaga,
	ICrudProviderAttrGlobalAssignConfirmSaga,
	ICrudProviderAttrGlobalAssignEditSaga,
	ICrudProviderAttrGlobalAssignPaginationSaga,
	ICrudProviderAttrGlobalAssignSaga
} from 'models/ProviderGlobalUploadInterface'
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import {
	providerAttrGlobalApplySuccess,
	providerAttrGlobalAssignConfirmSuccess,
	providerAttrGlobalAssignEditRes,
	providerAttrGlobalAssignPaginateSuccess,
	providerAttrGlobalAssignSuccess,
	providerAttrIndividualApplySuccess
} from '../actions'
import {
	EDIT_PROVIDER_ATTR_GLOBAL_ASSIGN,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN_CONFIRM,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN_PAGINATION,
	SET_PROVIDER_ATTR_GLOBAL_FILTERS,
	SET_PROVIDER_ATTR_INDIVIDUAL
} from '../constants/ActionsTypes'

function* providerAttrGlobalApplyReq({
	payload
}: ICrudApplyProviderAttrFiltersSaga): any {
	try {
		const values: any = yield call(providerAttrGlobalApply, payload)
		yield put(providerAttrGlobalApplySuccess(values))
	} catch (error) {}
}

function* providerAttrIndividualApplyReq({
	payload
}: ICrudApplyProviderAttrIndividualSaga): any {
	try {
		const values: any = yield call(providerAttrIndividualApply, payload)
		yield put(providerAttrIndividualApplySuccess(values))
	} catch (error) {}
}
function* providerAttrGlobalAssignConfirmReq({
	payload
}: ICrudProviderAttrGlobalAssignConfirmSaga): any {
	try {
		const values: any = yield call(providerAttrGlobalAssignConfirm, payload)
		yield put(providerAttrGlobalAssignConfirmSuccess(values))
	} catch (error) {}
}

function* providerAttrGlobalAssignEditReq({
	payload
}: ICrudProviderAttrGlobalAssignEditSaga): any {
	try {
		const values: any = yield call(providerAttrGlobalAssignEdit, payload)
		yield put(providerAttrGlobalAssignEditRes(values))
	} catch (error) {}
}
function* providerAttrGlobalAssignReq({
	payload
}: ICrudProviderAttrGlobalAssignSaga): any {
	try {
		const values: any = yield call(providerAttrGlobalAssign, payload)
		yield put(providerAttrGlobalAssignSuccess(values))
	} catch (error) {}
}
function* providerAttrGlobalAssignPaginationReq({
	payload
}: ICrudProviderAttrGlobalAssignPaginationSaga): any {
	try {
		const values: any = yield call(providerAttrGlobalAssignPaginate, payload)
		yield put(providerAttrGlobalAssignPaginateSuccess(values))
	} catch (error) {}
}
export function* providerAttrGlobalApplySaga() {
	yield takeLatest(SET_PROVIDER_ATTR_GLOBAL_FILTERS, providerAttrGlobalApplyReq)
}
export function* providerAttrIndividualApplySaga() {
	yield takeLatest(SET_PROVIDER_ATTR_INDIVIDUAL, providerAttrIndividualApplyReq)
}
export function* providerAttrGlobalAssignConfirmSaga() {
	yield takeLatest(
		SET_PROVIDER_ATTR_GLOBAL_ASSIGN_CONFIRM,
		providerAttrGlobalAssignConfirmReq
	)
}

export function* providerAttrGlobalAssignEditSaga() {
	yield takeLatest(
		EDIT_PROVIDER_ATTR_GLOBAL_ASSIGN,
		providerAttrGlobalAssignEditReq
	)
}
export function* providerAttrGlobalAssignSaga() {
	yield takeLatest(SET_PROVIDER_ATTR_GLOBAL_ASSIGN, providerAttrGlobalAssignReq)
}
export function* providerAttrGlobalAssignPaginationSaga() {
	yield takeLatest(
		SET_PROVIDER_ATTR_GLOBAL_ASSIGN_PAGINATION,
		providerAttrGlobalAssignPaginationReq
	)
}

export default function* rootSaga() {
	yield all([
		fork(providerAttrGlobalApplySaga),
		fork(providerAttrIndividualApplySaga),
		fork(providerAttrGlobalAssignConfirmSaga),
		fork(providerAttrGlobalAssignEditSaga),
		fork(providerAttrGlobalAssignSaga),
		fork(providerAttrGlobalAssignPaginationSaga)
	])
}
